import { useIntl } from 'react-intl';

import { messages } from '../messages';
import { Container, Copyright, DemoText, Footer } from './styles';

const CURRENT_YEAR = new Date().getFullYear();

export default function EmotionDetectorFooter() {
	const { formatMessage } = useIntl();

	return (
		<Footer>
			<Container>
				<Copyright>© {CURRENT_YEAR} Calm</Copyright>
				<DemoText>{formatMessage(messages.cameraFooterDemo)}</DemoText>
			</Container>
		</Footer>
	);
}
